export interface ScientificAnalysisImportModalState {
    file: File | null
}
export const initialScientificAnalysisImportModalState =
    (): ScientificAnalysisImportModalState => ({
        file: null
    })
